module.exports = __webpack_public_path__ + "media/images/airbnb-4574f563.png";